import type { BandProps } from './BandModule';
import { getClassName } from './getClassName';
import type { PropsWithChildren, HTMLAttributes } from 'react';

export type Attributes = Pick<
  BandProps,
  'contentAlignment' | 'transforms' | 'contained' | 'outline' | 'spacing' | 'swoosh'
> & {
  background: string;
};

type WrapperProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  attributes: Attributes;
};

export const Wrapper = ({ className = '', attributes, children, ...props }: WrapperProps) => (
  <div className={[className, getClassName(attributes)].join(' ')} {...props}>
    {children}
  </div>
);
